import { useEffect, useState } from 'react';

import CloseIcon from './CloseIcon';

interface UpdatePopoverProps {
  visible: boolean;
  currentVersion: string;
  latestVersion: string;
  packageName: string;
  onClose: () => void;
}

const LEAVE_ANIMATION_MS = 320;

const UpdatePopover = ({
  visible,
  currentVersion,
  latestVersion,
  packageName,
  onClose
}: UpdatePopoverProps) => {
  const [mounted, setMounted] = useState(visible);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (visible) {
      setMounted(true);
      setClosing(false);

      return;
    }

    if (!mounted) {
      return;
    }

    setClosing(true);
    const timeoutId = setTimeout(() => setMounted(false), LEAVE_ANIMATION_MS);

    return () => clearTimeout(timeoutId);
  }, [visible, mounted]);

  if (!mounted) {
    return null;
  }

  const stateClassName = closing
    ? 'eduzz-ui-version-popover--leave'
    : 'eduzz-ui-version-popover--enter';

  return (
    <div role='status' className={`eduzz-ui-version-popover ${stateClassName}`}>
      <button
        type='button'
        aria-label='Fechar'
        className='eduzz-ui-version-popover__close'
        onClick={onClose}
      >
        <CloseIcon className='eduzz-ui-version-popover__close-icon' />
      </button>
      <span className='eduzz-ui-version-popover__title'>⚠️ Atualização disponível</span>
      <br />
      Você está usando a v{currentVersion} do {packageName}. Teste a v{latestVersion} =]
    </div>
  );
};

export default UpdatePopover;
